<script lang="ts" setup>
import { useStoreConfig } from '~/store/storeConfig'
import Page from './Page.vue'
const { isMobile } = useStoreConfig()
const { isWhitelabel } = useTheme()
</script>

<template>
  <div>
    <Page :is-full-width="true">
      <template #header>
        <LayoutHeader v-if="isWhitelabel" />

        <template v-else>
          <LazyHeaderProCalculateMobile v-if="isMobile" />
          <div v-else>
            <LazyHeaderProCalculate />
            <LazyCategoryBar show-stores />
          </div>
        </template>
      </template>
      <slot />
    </Page>
  </div>
</template>
